export default "__VITE_ASSET__8d30aea2__"